//////////////////////////////////////////////////////
/// DO NOT EDIT                                    ///
/// Generated by Trygghetsfonden.Dataverse.Tools   ///
/// Source file: xrm.context.include.txt           ///
//////////////////////////////////////////////////////

export enum tsl_svarvidtelefon {
	Fickkontakt = 1,
	Ingetsvar = 2,
};
